import React from "react";
import { Link, useLocation } from "react-router-dom";
import { AlertTriangle, Home } from "lucide-react";
import Layout from "../components/Layout";
import { GhostButton } from "../components/PrimaryButton";

export default function Erro() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const reason = params.get("reason") || "geral";

  const messages = {
    token_expirado: {
      title: "Este link expirou",
      desc: "O link de remarcação tem validade limitada. Por favor entre em contato pelo WhatsApp da clínica para receber um novo link.",
    },
    token_invalido: {
      title: "Link inválido",
      desc: "Não conseguimos validar este link. Verifique se você abriu o ultimo link enviado pela clínica.",
    },
    token_ja_utilizado: {
      title: "Link ja utilizado",
      desc: "Esta remarcação ja foi realizada. Caso precise alterar novamente, entre em contato com a clínica.",
    },
    geral: {
      title: "Algo deu errado",
      desc: "Tivemos um problema ao processar sua solicitação. Tente novamente em instantes.",
    },
  };
  const m = messages[reason] || messages.geral;

  return (
    <Layout>
      <div className="fade-up text-center pt-6">
        <div className="w-20 h-20 mx-auto rounded-full bg-amber-100 flex items-center justify-center text-amber-700">
          <AlertTriangle size={36} strokeWidth={2} />
        </div>
        <h1 className="text-2xl sm:text-3xl tracking-tight font-bold text-slate-900 mt-5" style={{ fontFamily: "Manrope" }} data-testid="erro-title">
          {m.title}
        </h1>
        <p className="text-slate-600 mt-2 leading-relaxed">{m.desc}</p>
      </div>

      <div className="mt-8">
        <Link to="/">
          <GhostButton data-testid="erro-home">
            <Home size={18} /> Voltar ao inicio
          </GhostButton>
        </Link>
      </div>
    </Layout>
  );
}
